module.exports = __webpack_public_path__ + "static/img/guarantee3.041f63f1.png";